import React, { memo, useEffect, useState } from 'react'
import { Button, HeadingText, Link, Avatar } from '@paypalcorp/pp-react'
import { Message } from '@paypalcorp/worldready-react'
import DsrBanner from '../common/dsr-banner'
import { ZETTLE_US_URL } from '../../../constants/constants'
import { fptiCustomSetup, fptiCustomClick } from '../../../utils'

const TokenExpired = memo((props) => {
  const [impressionDone, setImpressionDone] = useState(false)
  const { dsrFpti = {} } = props

  useEffect(() => {
    if (!impressionDone) {
      setImpressionDone(true)
      fptiCustomSetup(dsrFpti.EMAILVERIFICATION_EXPIRED_IMPRESSION)
    }
  }, [impressionDone, dsrFpti])
  const bannerContent = {
    header: (
      <Message id="dsrZettle.email.verification.token.expired.header.title" />
    ),
    description: '',
  }
  const handleLinkClick = (event) => {
    event.preventDefault()
    fptiCustomClick(dsrFpti.EMAILVERIFICATION_EXPIRED_LINKCLICK)
    location.href = ZETTLE_US_URL
  }
  return (
    <>
      <DsrBanner {...bannerContent} />
      <section className="page-body-container">
        <div className="inner-container">
          <section className="common-screen">
            <div className="flex-center">
              <Avatar
                src="https://www.paypalobjects.com/paypal-ui/illustrations/focused/svg/empty-critical.svg"
                className="focusedimg"
                alt="error"
              />
            </div>
            <HeadingText size="sm" className="text-center">
              <Message id="dsrZettle.email.verification.token.expired.title" />
            </HeadingText>
            <p className="text-center">
              <span>
                <Message id="dsrZettle.email.verification.body.requestid" />
              </span>
              <span>: {props.reqid}</span>
            </p>
            <div className="button-container">
              <Button size="sm" as={Link} secondary>
                <Message
                  id="dsrZettle.email.verification.body.another.request"
                  link={(innerMessage) => (
                    <Link href="/" onClick={handleLinkClick}>
                      {innerMessage}
                    </Link>
                  )}
                />
              </Button>
            </div>
          </section>
        </div>
      </section>
    </>
  )
})
TokenExpired.displayName = 'TokenExpired'

export default TokenExpired
